module.exports = "/_next/static/images/Cradlepoint-2bfccf44e0fe5141d12c6420b3cc3ba3.png";